// extracted by mini-css-extract-plugin
export default {"btns":"Devices_btns__FWlE1"};